
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireforkedarnathtrip() {



    const cardData =
    {
        keyword: 'Bus Hire For Kedarnath Trip',
        heading: 'Amruta Travels: Bus Hire For Kedarnath Trip',
        headingDescription: 'Amruta Travels offers Bus Hire for Pune to Kedarnath Trip, providing a reliable and comfortable transportation solution for your pilgrimage to the sacred Kedarnath Temple. Whether you are planning a spiritual journey with family, friends, or a group tour, our well-maintained buses ensure a smooth and devotional experience. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your Pune to Kedarnath trip simple and stress-free. Book your bus with Amruta Travels and embark on a journey of faith and comfort!',


        top: 'Top Places to Visit in Kedarnath with Amruta Travels',
"topPlaces": [
  {
    "title": "Kedarnath Temple",
    "description": "Situated at an altitude of 3,583 meters in the Rudraprayag district of Uttarakhand, Kedarnath Temple is one of the twelve Jyotirlingas of Lord Shiva and a significant part of the Chota Char Dham pilgrimage. Believed to have been originally built by the Pandavas and later revived by Adi Shankaracharya in the 8th century, the temple is constructed from massive stone slabs and stands resilient amidst the Garhwal Himalayas. The temple is accessible via a 16-kilometer trek from Gaurikund, offering pilgrims a journey through breathtaking landscapes. The temple remains open to devotees from late April to early November, closing during the harsh winter months due to heavy snowfall."
  },
  {
    "title": "Bhairavnath Temple",
    "description": "Located approximately 500 meters from the Kedarnath Temple, Bhairavnath Temple is dedicated to Bhairava, a fierce manifestation of Lord Shiva. It is believed that Bhairava protects the Kedarnath Temple during the harsh winter months when it remains closed. The temple offers panoramic views of the surrounding valleys and snow-capped peaks, making it a spiritually and visually enriching experience for visitors."
  },
  {
    "title": "Chorabari Tal (Gandhi Sarovar)",
    "description": "Situated about 3 kilometers from Kedarnath, Chorabari Tal, also known as Gandhi Sarovar, is a serene glacial lake formed by the melting of the Chorabari Glacier. The lake holds historical significance as some of Mahatma Gandhi's ashes were immersed here. The trek to the lake is moderately challenging and offers stunning views of the Himalayan landscape, making it a popular spot for both pilgrims and trekkers."
  },
  {
    "title": "Vasuki Tal",
    "description": "Approximately 8 kilometers from Kedarnath, Vasuki Tal is a high-altitude glacial lake situated at an elevation of 4,135 meters. Surrounded by towering Himalayan peaks, the lake is known for its crystal-clear waters and tranquil environment. The trek to Vasuki Tal is considered challenging, making it suitable for experienced trekkers seeking solitude and natural beauty."
  },
  {
    "title": "Gaurikund",
    "description": "Gaurikund serves as the base camp for the trek to Kedarnath Temple. It is named after Goddess Parvati (Gauri), who is believed to have meditated here to win Lord Shiva's affection. The town features a temple dedicated to Gauri and natural hot springs, which are considered sacred by pilgrims. Gaurikund is accessible by road and offers basic amenities for travelers beginning their pilgrimage."
  },
  {
    "title": "Kedarnath Wildlife Sanctuary",
    "description": "Also known as the Kedarnath Musk Deer Sanctuary, this protected area spans over 975 square kilometers and is home to a diverse range of flora and fauna, including the endangered Himalayan musk deer. The sanctuary offers opportunities for wildlife observation, trekking, and experiencing the rich biodiversity of the Garhwal Himalayas. It serves as a vital ecological zone and adds to the spiritual ambiance of the region."
  },
  {
    "title": "Adi Shankaracharya Samadhi",
    "description": "Located near the Kedarnath Temple, this samadhi marks the final resting place of Adi Shankaracharya, the 8th-century philosopher and theologian who played a crucial role in reviving Hinduism. The site holds immense spiritual significance and is a place of reflection and reverence for devotees visiting Kedarnath."
  },
  {
    "title": "Triyuginarayan Temple",
    "description": "Situated approximately 25 kilometers from Kedarnath, Triyuginarayan Temple is believed to be the sacred site where Lord Shiva and Goddess Parvati were married. The temple features an eternal flame that is said to have witnessed the divine union. The site is a popular destination for couples seeking blessings for a harmonious marriage."
  },
  {
    "title": "Guptkashi",
    "description": "Located about 47 kilometers from Kedarnath, Guptkashi is a town of religious significance, housing ancient temples like Vishwanath and Ardhnarishwar. According to legend, Lord Shiva hid here to avoid the Pandavas, hence the name 'Guptkashi' or 'Hidden Kashi.' The town offers panoramic views of the Chaukhamba peaks and serves as a convenient stopover for pilgrims en route to Kedarnath."
  },
  {
    "title": "Sonprayag",
    "description": "Situated at the confluence of the rivers Basuki and Mandakini, Sonprayag is a picturesque location approximately 20 kilometers from Kedarnath. It serves as a key point for pilgrims, offering facilities like accommodation and transportation. The site holds religious importance, and a dip in the confluence is considered purifying by devotees."
  }
],



"services": [
    {
      "name": "Luxury Bus Hire For Kedarnath Trip",
      "description": "Amruta Travels offers luxury bus hire for Kedarnath Yatra from Pune, tailored for spiritual seekers looking for comfort and convenience. Our buses come equipped with plush seating, AC, and ample luggage space, ensuring a peaceful journey to the sacred Himalayan shrine."
    },
    {
      "name": "Luxury Coach Booking for Uttarakhand Tourism Kedarnath Trip From Pune",
      "description": "Book premium luxury coaches from Pune to Kedarnath with Amruta Travels, perfect for religious groups and family tours. Our coaches are designed for long-distance comfort and safety, making your Uttarakhand pilgrimage memorable and stress-free."
    },
    {
      "name": "Bus Hire For Kedarnath Trip",
      "description": "We provide reliable bus rental services for the Kedarnath Yatra from Pune. Whether for small or large groups, our fleet includes well-maintained buses suitable for hilly terrain and long travel durations, handled by experienced drivers."
    },
    {
      "name": "Char Dham Yatra Bus Package from Pune",
      "description": "Embark on the spiritual Char Dham Yatra from Pune with Amruta Travels’ specially curated bus packages. Cover Yamunotri, Gangotri, Kedarnath, and Badrinath in one seamless journey with guided stops, hotel arrangements, and dedicated support throughout."
    },
    {
      "name": "Pune to Badrinath Bus Tour Package",
      "description": "Travel to the holy temple of Badrinath with Amruta Travels' exclusive bus tour package. Our Pune to Badrinath service includes comfortable AC buses, stopovers, and professional coordination for a smooth and enriching spiritual experience."
    },
    {
      "name": "Pune to Vrindavan Bus Tour Package",
      "description": "Join our bus tour from Pune to Vrindavan, the land of Lord Krishna. Amruta Travels offers AC and sleeper buses for this religious journey, with guided visits to Banke Bihari Temple, ISKCON, and other sacred spots in Vrindavan and Mathura."
    },
    {
      "name": "Vrindavan Tour Packages from Pune",
      "description": "Explore Vrindavan with customized tour packages by Amruta Travels. We provide comfortable bus transportation from Pune, along with accommodation and sightseeing arrangements to ensure a fulfilling devotional tour."
    },
    {
      "name": "Pune to Kullu Manali Bus Tour Package",
      "description": "Experience the scenic beauty of Himachal with our Pune to Kullu Manali bus tour package. Amruta Travels offers comfortable travel for families, friends, and honeymooners, complete with sightseeing, hotel stays, and onboard entertainment."
    },
    {
      "name": "Pune to Amarnath Yatra Bus Tour Package",
      "description": "Plan your pilgrimage to Amarnath with our Pune to Amarnath Yatra Bus Tour. We offer AC tourist buses with experienced staff to support your spiritual journey to one of the holiest shrines in India, with safety and comfort as our priority."
    }
  ],
  "tableData": [
    ["Luxury Bus Hire For Kedarnath Trip", "Luxury Coach Booking for Uttarakhand Tourism Kedarnath Trip From Pune"],
    ["Bus Hire For Kedarnath Trip", "Char Dham Yatra Bus Package from Pune"],
    ["Pune to Badrinath Bus Tour Package", "Pune to Vrindavan Bus Tour Package"],
    ["Vrindavan Tour Packages from Pune", "Pune to Kullu Manali Bus Tour Package"],
    ["Pune to Amarnath Yatra Bus Tour Package", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Bus Hire for Kedarnath Yatra from Pune",
    "WhyChoosedescription": "Amruta Travels offers dependable and comfortable bus hire services for groups planning the sacred Kedarnath Yatra from Pune. This spiritually significant journey requires long-distance travel, proper coordination, and safe transportation through mountainous terrain. We provide well-maintained vehicles and professional support to make your pilgrimage peaceful, secure, and spiritually enriching from start to finish."
  },
  {
    "WhyChooseheading": "Perfect for Devotees, Pilgrimage Groups, and Religious Tour Organizers",
    "WhyChoosedescription": "Our Kedarnath trip bus service is ideal for spiritual groups, elderly yatris, family pilgrims, and religious tour operators. Whether it’s a small group or a large batch of devotees, we offer full itinerary customization, including overnight halts, stopovers at other Char Dham sites, and temple visit coordination to ensure every participant experiences the journey with devotion and ease."
  },
  {
    "WhyChooseheading": "Spacious, Comfortable Buses for Long-Distance Travel",
    "WhyChoosedescription": "Choose from AC and Non-AC buses ranging from 17 to 50 seaters based on your group size. All buses come equipped with push-back seats, ample legroom, luggage compartments, and onboard amenities for a comfortable ride during the long journey from Pune to Kedarnath base points like Sonprayag or Guptkashi. Our vehicles are designed for long travel hours while keeping passenger fatigue minimal."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Hilly Terrain and Pilgrim Routes",
    "WhyChoosedescription": "Our drivers are experienced in long-distance pilgrimage tours and are trained to handle hilly terrain, narrow roads, and traffic conditions in Uttarakhand. They follow safe driving practices and are well-aware of stopover locations, temple access points, and government guidelines, ensuring your group's journey is smooth and safe throughout."
  },
  {
    "WhyChooseheading": "Customizable Kedarnath Yatra Plans Including Char Dham Add-ons",
    "WhyChoosedescription": "Amruta Travels provides full customization of your Kedarnath Yatra itinerary. You can choose to extend the trip to include Badrinath, Yamunotri, Gangotri, or even Haridwar and Rishikesh. We assist in planning your stops, accommodations (upon request), walking/pony route coordination from Sonprayag, and return timing to ensure every detail is handled carefully."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Multi-Day Trips",
    "WhyChoosedescription": "Our Kedarnath bus hire packages are designed to be cost-effective, with clear and upfront pricing. We include all major travel costs such as fuel, tolls, interstate permits, driver allowance, and taxes. There are no hidden fees, and we work with your group’s budget to offer suitable options whether you’re seeking an economical or premium travel experience."
  },
  {
    "WhyChooseheading": "Clean, Safe, and Well-Maintained Buses for Pilgrimage Comfort",
    "WhyChoosedescription": "All our buses undergo rigorous maintenance and pre-trip inspections, especially for high-altitude routes. Interiors are sanitized, seating is clean and comfortable, and emergency support is readily available. We understand the devotional nature of this trip and ensure a calm, respectful atmosphere inside the bus for bhajans, prayer, and group discussions."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Support During the Yatra",
    "WhyChoosedescription": "Booking your Kedarnath trip bus from Pune is simple with Amruta Travels. Our support team helps you with route planning, required documents, and updates on travel restrictions. During the trip, we offer continuous support via phone and WhatsApp to assist with delays, emergencies, or changes—ensuring peace of mind throughout your sacred journey."
  }
]

















    }

const faqData = [
  {
    question: 'Can I hire a bus from Pune for a Kedarnath trip?',
    answer: 'Yes, Amruta Travels offers long-distance bus rental services from Pune to Kedarnath. We provide comfortable buses with experienced drivers for religious tours and pilgrimages, including Kedarnath as part of Char Dham or standalone yatra.',
  },
  {
    question: 'What is included in the Kedarnath bus hire package?',
    answer: 'Our package includes the bus rental (AC or non-AC), licensed driver, fuel, tolls, and permits required for interstate travel. Accommodation, meals, and sightseeing can be arranged on request.',
  },
  {
    question: 'What types of buses are available for the Kedarnath trip?',
    answer: 'We offer 32, 35, 40, 45, and 50-seater buses, both in AC and non-AC variants. Luxury coaches with push-back seats, extra luggage space, and entertainment systems are also available for added comfort during the long journey.',
  },
  {
    question: 'How many days are required for a Pune to Kedarnath trip by bus?',
    answer: 'A typical round-trip from Pune to Kedarnath takes around 10–14 days, depending on the itinerary, stops, and whether it’s part of a broader Char Dham Yatra.',
  },
  {
    question: 'Is the bus allowed to go directly to Kedarnath?',
    answer: 'No, buses can only go up to Sonprayag. From there, travelers must continue to Gaurikund by local transport and then proceed to Kedarnath either by trekking, pony, palanquin, or helicopter.',
  },
  {
    question: 'Is the Kedarnath tour suitable for senior citizens?',
    answer: 'Yes, many groups with senior citizens travel to Kedarnath. We recommend advance planning, rest stops, and possibly using helicopter services for the final leg to make the journey more comfortable.',
  },
  {
    question: 'Do you offer all-inclusive packages for Kedarnath Yatra?',
    answer: 'Yes, on request, we can arrange all-inclusive packages with bus travel, hotel stays, meals, permits, and even helicopter bookings to Kedarnath.',
  },
  {
    question: 'How much does it cost to rent a bus for the Kedarnath trip from Pune?',
    answer: 'The cost depends on the number of days, bus type, group size, and services included. Contact us with your requirements for a detailed, customized quote.',
  },
  {
    question: 'Why choose Amruta Travels for the Kedarnath trip?',
    answer: 'Amruta Travels ensures safe, reliable, and spiritual journeys with trained drivers, comfortable buses, and flexible travel plans. We are experienced in managing long-distance pilgrimages from Pune to the Himalayas.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Mahadev Deshmukh',
    role: 'Group Yatra Coordinator, Pune',
    text: 'We hired a 45-seater bus for our Pune to Kedarnath Yatra. The service from Amruta Travels was exceptional. The driver was well-versed with the route and the journey was smooth and safe. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sangeeta Pawar',
    role: 'Devotee & Group Member',
    text: 'Our Kedarnath pilgrimage with Amruta Travels was very well organized. The bus was comfortable, and everything was managed professionally from Pune to Sonprayag. A divine and stress-free experience!',
    rating: 5,
  },
];

































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire For Kedarnath Trip",
  "image": "https://bushireinpune.com/assets/images/bus-hire-for-kedarnath-trip.jpg",
  "description": "Book a luxury bus for your Kedarnath Trip from Pune with Amruta Travels. We offer customized bus packages for Char Dham Yatra, including Kedarnath, Badrinath, Amarnath, and Vrindavan tours. Enjoy a comfortable and safe journey in luxury coaches with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999", // Adjust price based on specific Kedarnath package
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-for-kedarnath-trip"
  }
};



    return (
        <div>



<Helmet>
  <title>Call: +91 7353109555 | Bus Hire For Kedarnath Trip | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book a luxury bus for your Kedarnath Trip from Pune. Customized Char Dham Yatra packages, including Kedarnath, Badrinath, Amarnath, and Vrindavan tours. Luxury coach services for a comfortable journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/56.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforkedarnathtrip;